import * as ReselectModule from "reselect";
import { IClientRightGroupListState } from ".";
import { IApplicationState } from "..";

export const selectClientRightGroupList: ReselectModule.Selector<
  IApplicationState,
  IClientRightGroupListState
> = (state) => state.clientRightGroupList;
